import { PublicKey } from "@solana/web3.js";
export const PROGRAM_ID = new PublicKey("1azyuavdMyvsivtNxPoz6SucD18eDHeXzFCUPq5XU7w");
//# sourceMappingURL=constants.js.map